<template>
  <form>
    <div class="w-100 vh-100 d-flex flex-column justify-content-center align-items-center gap-2">
      <div class="d-flex justify-content-center align-items-start flex-column gap-2">
        <div class="form-group w-100" v-if="!otherDrinkRequested">
          <label>Drink</label>
          <select class="form-select" v-model="drink">
            <option v-for="item in drinksList" :key="item.value" :disabled="item.value === '--Seleziona un drink--'"
              :value="item.value">{{ item.text }}</option>
          </select>
        </div>
        <div class="form-group">
          <label for="inputName">Nome</label>
          <input type="text" class="form-control" id="inputName" placeholder="Il tuo Nome" v-model="name">
        </div>
        <div class="form-group" v-if="otherDrinkRequested">
          <label for="inputOther">Altro</label>
          <input type="text" class="form-control" id="inputOther" placeholder="Drink Alternativo" v-model="other">
        </div>
        <div class="form-group">
          <input class="form-check-input me-2" type="checkbox" name="checkOther" id="unlockOther"
            :checked="otherDrinkRequested" @input="otherDrinkRequested = !otherDrinkRequested">
          <label for="unlockOther">Altro Drink</label>
        </div>
      </div>
      <button type="button" class="btn btn-primary" @click="addOrder()">Invia al Barman</button>
    </div>
  </form>
</template>

<script>
import axios from "axios";
import queryString from "query-string";
import { showToastNotification } from "../js/toastify";
const URL = "https://script.google.com/macros/s/AKfycbzVs_bCYvWWghmM5uvvrBGUahQK3qBs3nziXmnncUeNPH69-DjZjAMZiT7svnMWDQH1IQ/exec";
const DRINK_DEFAULT = "--Seleziona un drink--";

export default {
  name: 'App',
  components: {},
  data: () => ({
    drinksList: [{ text: DRINK_DEFAULT, value: DRINK_DEFAULT }],
    drink: DRINK_DEFAULT,
    name: null,
    other: null,
    isButtonEnabled: true,
    showLoadingModal: true,
    otherDrinkRequested: false,
  }),
  methods: {
    getDrinksList() {
      axios.get(URL).then(res => {
        if (res.status === 200) {
          const drinks = res.data;
          drinks.forEach(drink => {
            this.drinksList.push({ text: drink, value: drink });
          });
          this.showLoadingModal = false
        }
      }).catch(err => {
        console.log(err);
      })
    },
    addOrder() {
      let valid = true;
      const error = {};
      if (this.otherDrinkRequested) {
        this.drink = "ALTRO DRINK";
      }
      else {
        if (this.drink === DRINK_DEFAULT) {
          valid = false;
          error.drink = true;
        }
      }
      if (this.name === null || this.name === "") {
        valid = false;
        error.name = true;
      }
      if (valid) {
        this.isButtonEnabled = false
        const data = { name: this.name, drink: this.drink, other: this.other }
        const config = {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded"
          }
        };
        axios.post(URL,
          queryString.stringify(data, config)
        ).then(res => {
          if (res.status === 200) {
            console.log(res);
            this.drink = DRINK_DEFAULT
            this.name = null;
            this.other = null;
            showToastNotification("Ordinazione inviata!", 'success')
          }
        }).catch(err => {
          showToastNotification("Si è verificato un errore, riprova ad effettuare l'ordine!", 'danger')
          console.log(err);
        }).finally(() => this.isButtonEnabled = true)
      } else {
        let toastText = "Per effettuare un'ordinazione ";
        if (error.drink) {
          toastText += "seleziona il drink";
        }
        if (error.name) {
          if (error.drink) {
            toastText += " ed inserisci il nome"
          } else {
            toastText += "inserisci il nome"
          }
        }
        showToastNotification(toastText, 'warning');
      }
    }
  },
  mounted() {
    this.getDrinksList();
  }
}
</script>